import styled from 'styled-components'
import { SmartTemplate as SmartTemplateBase } from 'pages/documents/components/smart-template'

export const SmartTemplate = styled(SmartTemplateBase)`
    margin-block-end: 16px;
`